'use client'

import { ThemeProvider } from 'styled-components'
import theme from '@/styles/theme'
import React from 'react'
import { SideModalProvider } from '@contexts/SideModalContext'
import SideModal from '@components/Modal/SideModal'

import { AuthProvider } from '@/contexts/AuthContext'
import { SyncProvider } from '@/contexts/SyncContext'
import { ConfigProvider } from '@/contexts/ConfigContext'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { UIProvider } from '@/contexts/UIContext'
import { ThemeProvider as CustomThemeProvider } from '@/contexts/ThemeContext'
import { ProProvider } from '@/contexts/ProContext'
import { UpdateProvider } from '@/contexts/UpdateContext'

import FontLoader from '@/components/Layouts/FontLoader'
import GlobalStyle from '@/styles/globalStyles'

import ElectronWelcomeModal from '@/components/Modal/ElectronWelcomeModal'
import AnalyticsInit from '@/components/Analytics/AnalyticsInit'

export default function ClientProviders({ children, initialLanguage }) {
    return (
        <CustomThemeProvider>
            <ThemeContextConsumer>
                {({ activeTheme }) => (
                    <ThemeProvider theme={{ ...theme, ...activeTheme }}>
                        {/* initialLanguage lo resuelve el servidor en app/layout.js */}
                        <LanguageProvider initialLanguage={initialLanguage}>
                            <AuthProvider>
                            <SyncProvider>
                                <UIProvider>
                                        <ProProvider>
                                        <UpdateProvider>
                                        <ConfigProvider>
                                            <SideModalProvider>
                                                <SideModal />
                                                <AnalyticsInit />
                                                <FontLoader>
                                                    <GlobalStyle />
                                                    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                                                        <ElectronWelcomeModal />
                                                        <div style={{ flex: 1, overflow: 'hidden', position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                                            {children}
                                                        </div>
                                                    </div>
                                                </FontLoader>
                                            </SideModalProvider>
                                        </ConfigProvider>
                                        </UpdateProvider>
                                        </ProProvider>
                                    </UIProvider>
                            </SyncProvider>
                            </AuthProvider>
                        </LanguageProvider>
                    </ThemeProvider>
                )}
            </ThemeContextConsumer>
        </CustomThemeProvider>
    )
}

import { useTheme } from '@/contexts/ThemeContext'
function ThemeContextConsumer({ children }) {
    const themeData = useTheme()
    return children(themeData)
}
